import script from "./HeaderTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTabs.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTabs.vue?vue&type=style&index=0&id=5988fe99&lang=scss"

const __exports__ = script;

export default __exports__